import { Injectable } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { CourtEventNoteSaveModalComponent } from '../containers/court-event-note-save-modal/court-event-note-save-modal.component';
import { CourtEventNoteSaveInputModel } from '../models/court-event-note-save-input.model';

@Injectable({
  providedIn: 'root'
})
export class CourtEventNoteSaveLauncherService {
  constructor(private bsModalService: BsModalService) {}

  openCourtNoteSave(model: CourtEventNoteSaveInputModel) {
      this.bsModalService.show(CourtEventNoteSaveModalComponent, {
          id: 'court-event-note-save',
          //class: 'fullscreen',
          initialState: { courtEventInput: model }
      });
  }
}
